export default "__VITE_ASSET__YwBhrFt9__"